import React from 'react'
import styles from './StoreList.module.css'
import height from './height.module.css'

export default function Food(props) {
    return (
        <div className={`container ${height.slush} ${height.food2}`}>
            {props.food ?
                <>
                    <div>
                        <h4 className="row"><u>Slushee &amp; Dessert Lab</u></h4>
                    </div>
                    <div className="row">
                        <p className="col">Dessert Lab Hours:</p>
                        <p className={`col righttext`}>{props.dessertLabOpen} - {props.dessertLabClose}</p>
                    </div>
                </>
                :<><h4 className="row"><u>Slushee Only</u></h4></>
            }
            {props.food?<div className={`row`}>
                <p className="col">Slushee Hours:</p>
                <p className={`col righttext`}>{props.slushOpen} - {props.slushClose}</p>
            </div>:<div className={`row my-4`}>
                <p className="col">Slushee Hours:</p>
                <p className={`col righttext`}>{props.slushOpen} - {props.slushClose}</p>
            </div>}
            
            <div className="row">
                <p className={`col ${styles.subCard}`}>{props.flavours} Flavours of Slush</p>
                {props.sitIn && props.takeaway ?
                    <p className={`col ${styles.subCard}`}>Sit-In &amp; Takeaway</p>
                    :
                    props.sitIn && props.takeaway === false ?
                        <p className={`col ${styles.subCard}`}>Sit-In Only</p>
                        : props.sitIn === false && props.takeaway ?
                            <p className={`col ${styles.subCard}`}>Takeaway Only</p>
                            : <></>
                }
            </div>
        </div>
    )
}
